export class SSIMUtils {

  static actionFromSSIMActions = {
    C: 'X',
    D: 'X',
    R: 'K'
  };

  public static getSSIMOperationDaysFromNumberDay(operationDayNumber: number): string {
    return `${'0'.repeat(operationDayNumber - 1)}${operationDayNumber}${'0'.repeat(7 - operationDayNumber)}`;
  }

  public static getSSIMOperationDaysFromInputString(value: string): string {

    if (!value || value === '') { return value; }
    if (!SSIMUtils.validateSSIMOperationDays(value)) { return value; }

    let finalValue = '';
    for (let i = 1; i <= 7; i++) {
      const posicion: number = value.indexOf(i.toString());
      if (posicion !== -1) {
        finalValue = finalValue + String(i);
      } else {
        finalValue = finalValue + '0';
      }
    }
    return finalValue;
  }

  public static validateSSIMOperationDays(value: string): boolean {
    if (!value || value === '') { return true; }
    const regExp = (/^[0-9]*$/);
    if (regExp.test(value) && value.length <= 8) {
      if (Number(value) === 0) { return false; }
      for (let i = 1; i <= 7; i++) {
        if (value.split(String(i)).length - 1 > 1) {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  }

}
